import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { CopyIcon } from '../../../GenericComponents/copyIcon'
import { decodeHtml } from '../../../Utils';

function HighTextLinkDisplay(props: any) {
    const linkRef = useRef<HTMLAnchorElement>(null);

    const content = props.valText; //FP-12118- Already passing empty from parent compoennt no need extra check props.valText || '-'

    const decodedContent = decodeHtml(content);
    const hasHTML = /<\/?[a-z][\s\S]*>/i.test(decodedContent);

    const handleLinkClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        event.preventDefault();
        if (linkRef.current) {
            linkRef.current.style.color = '#e17009';
            linkRef.current.style.textDecoration = 'none';
        }
        if (props.onClick) {
            props.onClick(event);
        }
    };
    return (
        <>
            {/* <div className="top-section"> */}
            {props !== null && (
                <span>
                    <b key={props.headerText} data-column-name={props.headerText}>{props.headerText}:&nbsp; </b>
                    {
                        !props.isLink ? (
                            hasHTML ? (
                                <span
                                    id={props.id}
                                    dangerouslySetInnerHTML={{ __html: decodedContent + ' ' }}
                                />
                            ) : (
                                <span id={props.id}>
                                    {props.valText}
                                </span>
                            )) : (
                            <a
                                id={props.id}
                                href={props.href || ''}
                                ref={linkRef}
                                onClick={handleLinkClick}
                            >
                                {props.valText}
                                {/* {props.valText} &nbsp; &nbsp; */}
                            </a>
                        )
                        // <span>{props.valText || "-"} &nbsp; &nbsp;</span>
                    }
                    { props.valText && //FP-12118- does not require copy icon if no text
                        <span>
                        <CopyIcon copyText={props.valText} id={''} />   {/* this is change is for hightextdrillthru  */}
                        {' '}
                    </span>
                    }
                    {/* <span>{columnVal?.length > 10 ? columnVal?.slice(0, 10) + '...' : columnVal as string || "-"} &nbsp; &nbsp;</span> */}
                </span>
            )}
            {/* </div> */}
            {/* <div className="bottom-section"></div> */}
        </>
    )
}

HighTextLinkDisplay.propTypes = {
    headerText: PropTypes.string.isRequired,
    id: PropTypes.string,
    href: PropTypes.string,
    isLink: PropTypes.bool,
    onClick: PropTypes.func,
    valText: PropTypes.string.isRequired,
}

export default HighTextLinkDisplay
